import React, { 
    useState,
    useEffect
} from 'react';

import { useDispatch, useSelector } from 'react-redux';

import swal from 'sweetalert';

import { 
    selectDiasAlmuerzo,
    selectCategoriasAlmuerzoSemanaActiva,
    selectCategoriasAlmuerzo,
    selectIsLoading,
    selectIsSuccess,
    selectMessage,
    selectValidacionSubsidioComidaEmpleadoAplica,
    selectEmpleadosPorArea,
    fetchGetDiasAlmuerzo,
    fetchCambiarSuccess,
    selectMenuComidaEmpleadoSemana,
    fetchGetCategoriasAlmuerzoSemanaActiva,
    fetchGetCategoriasAlmuerzo,
    fetchSaveMenuComidaEmpleadoSemana,
    fetchGetMenuComidaEmpleadoSemana,
    fetchValidacionSubsidioComidaEmpleadoAplica,
} from '../../../redux/Cafeteria/CafeteriaSlice';

import { selectUserData } from "../../../redux/Login/LoginSlice";

import { 
    generarSeleccionMenuEmpleado,
    generarAlmuerzoMenuListEmpleado,
    generarResumenMenu,
    generarListaSeleccionComidaEmpleadoApi
} from '../../../pages/Cafeteria/Functions/CafeteriaFunctionsDigitarComida';

import { SeleccionAlmuerzoListaEmpleados } from '../Page/SeleccionAlmuerzoListaEmpleados';

import { 
    Step, 
    StepButton, 
    Stepper, 
    Typography
} from '@mui/material';

import Loading from '../../../Components/Modals/Loading/Loader';
import { removeAccents } from '../../../utils';

export const RegistrarMenuListaEmpleadosTabs = () => {

    // ? HOOK-DISPATCH
    const dispatch = useDispatch();

    // ? HOOK-SELECTOR
    const menuEmpleadoSemana = useSelector(selectMenuComidaEmpleadoSemana)
    const diasSemanas = useSelector(selectDiasAlmuerzo);
    const categoriasAlmuerzoSemanaActual = useSelector(selectCategoriasAlmuerzoSemanaActiva)
    const categorias = useSelector(selectCategoriasAlmuerzo);
    const { Id : usuarioId} = useSelector(selectUserData);
    const isLoading = useSelector(selectIsLoading);
    const message = useSelector(selectMessage);
    const success = useSelector(selectIsSuccess);
    const validacionAplicaSubsidioComida = useSelector(selectValidacionSubsidioComidaEmpleadoAplica);
    const empleados = useSelector(selectEmpleadosPorArea);

    // ? HOOK-STATE PARA LA PAGINACION DE PAGINAS.
    const [stepPosition, setStepPosition] = useState({position: 0, diaId: 0}); 

    // ? HOOK-STATE MENU ALMUERZO DIA EMPLEADO.
    const [almuerzoMenuListEmpleado, setAlmuerzoMenuListEmpleado] = useState([]);

    // ? HOOK-STATE SELECCION DE COMIDA POR DIA DEL EMPLEADO
    const [seleccionMenuEmpleado, setSeleccionMenuEmpleado] = useState({});

    // ? HOOK-STATE PARA GUARDAR EL RESUMEN DEL MENU DEL EMPLEADO
    const [resumenMenuState, setResumenMenuState] = useState({});

    // ? HOOK STATE PARA ALMACENAR LOS DIAS DE LUNES A VIERNES Y ADICIONAL EL RESUMEN DEL MENU SEMANAL.
    const [diasSemanaState, setDiasSemanaState] = useState([]);

    // ? HOOK-STATE PARA ALMACENAR EMPLEADOS-SELECCIONADOS
    const [empleadosAlmuerzoSeleccion, setEmpleadosAlmuerzoSeleccion] = useState([]);

    // ? HOOK-STATE PARA VALIDAR DE QUE SI ES UNA COMIDA QUE NO REQUIERE ACOMPAÑAMIENTO NI ENSALADA, ESTO DESHABILITA 
    // ? LOS RADIO-BUTTONS.
    const [disabledCategoriesFood, setDisabledCategoriesFood] = useState({});

    const [listaEmpleadosFilter, setListaEmpleadosFilter] = useState([]);

    // ? HOOK-EFFECT PARA REFRESCAR TODAS LAS LISTAS
    useEffect(() => {
        // dispatch(fetchValidacionSubsidioComidaEmpleadoAplica({empleadoId: usuarioId}));
        refreshAll();
    }, [])

    // ? HOOK-EFFECT PARA SWEET-ALERT
    useEffect(() => {

        if (success === "success" && message.length > 0) {
            swal("Exitoso!", message, "success", {
                timer: 1200,
            });

            // * RESET STATE.
            setStepPosition({position: 0, diaId: 1});
            dispatch(fetchCambiarSuccess());
            
            // * REFRESCAR TODAS LAS LISTAS NUEVAMENTE.
            refreshAll();
        } 
        else if (success === "error") {
            swal("Error", message, "error", {
                timer: 5000
            });

            dispatch(fetchCambiarSuccess());
        }
    }, [success]);

    // ? HOOK-EFFECT PARA GENERAR LA SELECCION DE MENU COMIDA DEL EMPLEADO.
    useEffect(() => {        
        setAlmuerzoMenuListEmpleado(generarAlmuerzoMenuListEmpleado(diasSemanas, categoriasAlmuerzoSemanaActual, 0));
        setSeleccionMenuEmpleado(generarSeleccionMenuEmpleado(diasSemanas, categorias, menuEmpleadoSemana));
    }, [diasSemanas, categorias, menuEmpleadoSemana, categoriasAlmuerzoSemanaActual])
    

    // ? HOOK-EFFECT PARA GENERAR EL RESUMEN DEL MENU DE LA SEMANA.
    useEffect(() => {
        setResumenMenuState(generarResumenMenu(seleccionMenuEmpleado, categoriasAlmuerzoSemanaActual, diasSemanas));
    }, [seleccionMenuEmpleado])


    // ? HOOK-STATE PARA AÑADIR UN NUEVO DIA DE SEMANA QUE ES EL RESUMEN DE LA SELECCION.
    useEffect(() => {
      setDiasSemanaState([{ id: 0, descripcion: "SELECCIÓN DEL PERSONAL"}, ...diasSemanas, { id: 6, descripcion: "RESUMEN DE LA SELECCIÓN"}]);
    }, [diasSemanas])

    useEffect(() => {
      
        if(empleados.length > 0){
            setListaEmpleadosFilter(empleados.filter(x => !x.existeRegistroCafeteria && x.seleccionadoEnGrupo === null))
        }

    }, [empleados])
    


    // * FUNCION PARA GUARDAR LA DATA SELECCIONADA EN LA API.
    const sendDataToApi = () => {
        
        // * FUNCION QUE GENERA EL ARRAY DE OBJETOS QUE SERA ENVIADO A LA API.
        const arrDataApi = generarListaSeleccionComidaEmpleadoApi(menuEmpleadoSemana, seleccionMenuEmpleado, categoriasAlmuerzoSemanaActual, diasSemanas);
    
        if(arrDataApi.length === 0){
            swal("Error", "Debe seleccionar mínimo una opción", "error", {
                timer: 2500,
            });

            return;
        }

        // console.log(arrDataApi);
        // console.log(arrDataApi);
        

        // * GUARDANDO DATA.
        // dispatch(fetchSaveMenuComidaEmpleadoSemana({empleadoId: usuarioId, data: arrDataApi}))
    }

    // * REFRESH-ALL
    const refreshAll = () => {
        dispatch(fetchGetMenuComidaEmpleadoSemana({empleadoId: usuarioId}))
        dispatch(fetchGetDiasAlmuerzo())
        dispatch(fetchGetCategoriasAlmuerzoSemanaActiva())
        dispatch(fetchGetCategoriasAlmuerzo())
    }

     // * COMPONENTE PARA ACTUALIZAR LA PAGINA SEGUN EL DIA ELEGIDO.
     const HandleSteps = ({ position }) => {

        let children = <></>;

        const categoriaAlmuerzoDiaEmpleado = almuerzoMenuListEmpleado.filter(x => x.diaId === position.diaId).map(x => x.categoriaAlmuerzo).flat();

        children = 
        <SeleccionAlmuerzoListaEmpleados
        diasSemanas={diasSemanas}
        categoriaAlmuerzoDiaEmpleado={categoriaAlmuerzoDiaEmpleado}
        setStepPosition={setStepPosition}
        stepPosition={stepPosition}
        setSeleccionMenuEmpleado={setSeleccionMenuEmpleado}
        seleccionMenuEmpleado={seleccionMenuEmpleado}
        resumenMenuState={resumenMenuState}
        sendDataToApi={sendDataToApi}
        disabledCategoriesFood={disabledCategoriesFood}
        setDisabledCategoriesFood={setDisabledCategoriesFood}
        empleados={listaEmpleadosFilter}
        setEmpleadosAlmuerzoSeleccion={setEmpleadosAlmuerzoSeleccion}
        empleadosAlmuerzoSeleccion={empleadosAlmuerzoSeleccion}
        />;         

        return children;
    };
   
    useEffect(() => {
        if (Object.keys(seleccionMenuEmpleado).length === 0 || almuerzoMenuListEmpleado.length === 0) return;
    
        const disabledCategoriesFoodUpdated = diasSemanas.reduce((acc, { descripcion: dia, id }) => {
            const diaNormalizado = removeAccents(dia);
            const menuEmpleado = seleccionMenuEmpleado[diaNormalizado];
    
            // Obtener las categorías de almuerzo del día
            const comidas = almuerzoMenuListEmpleado
                .filter(x => x.diaId === id)
                .flatMap(x => x.categoriaAlmuerzo)
                .flatMap(x => x.comidas);
    
            // Buscar las comidas seleccionadas
            const comidasSeleccionadas = Object.values(menuEmpleado)
                .map(comidaId => comidas.find(x => x.comidaId === comidaId) ?? {});
    
            // Verificar si alguna comida seleccionada deshabilita categorías
            const comidaDeshabilitarCategorias = comidasSeleccionadas.find(x =>
                !x.acompañamiento || !x.ensalada || !x.guarnicion
            ) ?? {};
    
            // Actualizar el objeto de categorías deshabilitadas
            acc[diaNormalizado] = Object.keys(comidaDeshabilitarCategorias).length > 0
                ? {
                    Acompanamiento: comidaDeshabilitarCategorias.acompañamiento,
                    Ensalada: comidaDeshabilitarCategorias.ensalada,
                    Guarnicion: comidaDeshabilitarCategorias.guarnicion,
                }
                : { Acompanamiento: true, Ensalada: true, Guarnicion: true };
    
            return acc;
        }, {});
    
        setDisabledCategoriesFood(disabledCategoriesFoodUpdated);
    
    }, [almuerzoMenuListEmpleado, success]);
    

    return (
        <>
            <Stepper disabled={!validacionAplicaSubsidioComida} alternativeLabel activeStep={menuEmpleadoSemana.length > 0 ? diasSemanaState.length : stepPosition.position} sx={{ marginTop: 2 }}>
            
            {
                diasSemanaState.length > 0 &&
                    diasSemanaState.map((item, index) =>

                        <Step key={index}>
                            <StepButton disabled={!validacionAplicaSubsidioComida} onClick={() => setStepPosition({position: index, diaId: item.id})}>
                                {item.descripcion}
                            </StepButton>
                        </Step>
                    )
            }

            </Stepper>

            <div style={{ marginTop: '3%' }}>
                <HandleSteps position={stepPosition} />
            </div>

            <Loading open={isLoading} />
        </>
    );
};